export default "__VITE_ASSET__DSVIV72K__"